import { render, staticRenderFns } from "./MyShareQrcode.vue?vue&type=template&id=8b6fefbe&scoped=true&"
import script from "./MyShareQrcode.vue?vue&type=script&lang=js&"
export * from "./MyShareQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6fefbe",
  null
  
)

export default component.exports